<!-- TABS -->
<eif-custom-tabs
	[tabs]="tabs"
	[activeTabId]="activeTabId"
	[actions]="tabActions"
	(tabChange)="onTabChange($event)"
	[class]="'mt-3 mb-4'">
	<div class="dashboard-tab-content">
		<!-- CONFIRMING AREA -->
		@if (loggedUser?.canSeeConfirmingOptions()) {
			@if (activeTabId === DASHBOARD_TAB_CONFIRMING) {
				<div>
					<!-- CURRENCIES -->
					@if (orderedCurrencies.length > 1) {
						<eif-custom-segmented-control
							[options]="currencyOptions"
							[value]="selectedCurrency"
							[class]="'mb-2'"
							[size]="'small'"
							[variant]="'outlined'"
							(valueChange)="clickedCurrency($event.toString())">
						</eif-custom-segmented-control>
					}
					<div class="dashboard-cards-wrap">
						<app-dashboard-metric-card
							card="confirming.notPaidDocuments"
							[value]="notPaidDocuments | currencyLocale: selectedCurrency"
							[loading]="loadingNotPaidDocuments" />
						<app-dashboard-metric-card
							card="confirming.approvedRequestFunds"
							[value]="confirmingApprovedRequestFunds | currencyLocale: selectedCurrency"
							[labelSuffix]="CurrentMonth?.toString()"
							[loading]="loadingConfirmingApprovedRequestFunds" />
						<app-dashboard-metric-card
							card="confirming.currentFundingRequestsAmount"
							[value]="currentFundingRequestsAmount | currencyLocale: selectedCurrency"
							[loading]="loadingCurrentFundingRequestsAmount" />
						<app-dashboard-metric-card
							card="confirming.suppliersActiveConnections"
							[value]="suppliersActiveConnections"
							[loading]="loadingSuppliersActiveConnections" />
					</div>
				</div>
			}
		}

		<!-- FACTORING AREA -->
		@if (loggedUser?.canSeeFactoringOptions()) {
			@if (activeTabId === DASHBOARD_TAB_FACTORING) {
				<div>
					<div class="dashboard-cards-wrap">
						<app-dashboard-metric-card
							card="factoring.portfolioAmount"
							[value]="factoringPortfolioAmount | currencyLocale: selectedCurrency"
							[loading]="loadingFactoringPortfolioAmount" />
						<app-dashboard-metric-card
							card="factoring.advancedAmount"
							[value]="factoringAdvancedAmount | currencyLocale: selectedCurrency"
							[loading]="loadingFactoringAdvancedAmount" />
						<app-dashboard-metric-card
							card="factoring.advanceableAmount"
							[value]="factoringAdvanceableAmount | currencyLocale: selectedCurrency"
							[loading]="loadingFactoringAdvanceableAmount" />
						<app-dashboard-metric-card
							card="factoring.buyersActiveConnections"
							[value]="factoringBuyersActiveConnections"
							[loading]="loadingFactoringBuyersActiveConnections" />
						<app-dashboard-metric-card
							card="factoring.pendingApprovalDocumentsAmount"
							[value]="factoringPendingApprovalDocumentsAmount"
							[loading]="loadingFactoringPendingApprovalDocumentsAmount"
							[hasAction]="true"
							(action)="navigateToFilesIntegration(FileStatus.PendingSupplierApproval)" />
					</div>
				</div>
			}
		}

		<!-- Charts area -->
		@if (activeTabId === DASHBOARD_TAB_CONFIRMING) {
			<div class="dashboard-chart-wrapper mt-4">
				<div class="is-label">
					{{ 'dashboard-supplier.documentForecast' | translate }}
				</div>
				@if (documentForecastChart.Results && documentForecastChart.Results.length > 0) {
					<app-document-forecast-chart
						[chart]="documentForecastChart"
						[currency]="selectedCurrency" />
				}
			</div>
		}
	</div>
</eif-custom-tabs>
